export default {"src":"/_next/static/media/MNT.215859a6.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};